import { PluginUtils } from 'owa-editor';
import { Editor, EditorPlugin } from 'roosterjs-editor-core';
import { ContentPosition } from 'roosterjs-editor-types';

export default class EditorOperationPlugin implements EditorPlugin {
    private editor: Editor;
    private pluginUtils: PluginUtils;

    public getName() {
        return 'EditorOperation';
    }

    public initialize(editor: Editor) {
        this.editor = editor;
    }

    public dispose() {
        this.editor = null;
    }

    public setPluginUtils(pluginUtils: PluginUtils) {
        this.pluginUtils = pluginUtils;
    }

    public insertNode(node: HTMLElement, wordToReplace?: string, rangeToSelect?: Range) {
        if (this.editor && !this.editor.isDisposed()) {
            this.editor.focus();

            const insertNodeCallback = () => {
                if (wordToReplace) {
                    this.pluginUtils.replaceWithNode(
                        this.editor,
                        wordToReplace,
                        node,
                        true /* exactMatch */
                    );
                } else {
                    this.editor.insertNode(node, {
                        position: ContentPosition.SelectionStart,
                        updateCursor: !!rangeToSelect,
                        replaceSelection: !rangeToSelect,
                        insertOnNewLine: rangeToSelect && node instanceof HTMLImageElement,
                    });
                }
            };

            this.editor.performAutoComplete(insertNodeCallback);
            if (rangeToSelect) {
                this.editor.select(rangeToSelect);
            }
        }
    }
}
